import { getMarkAsReadMutation } from './MarkAsReadMutation.generated';

const handleMarkAsRead = async ({ id, isRead }: NotificationFragment) => {
  if (!isRead) {
    await getMarkAsReadMutation({ notificationId: id });
  }
};

export default handleMarkAsRead;
